/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './defs.defs.js'

const $nsid = 'app.bsky.actor.searchActors'

export { $nsid }

/** Find actors (profiles) matching search criteria. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    term: l.optional(l.string()),
    q: l.optional(l.string()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 25),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    actors: l.array(
      l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
